// extracted by mini-css-extract-plugin
export var bubble = "_2d-0";
export var container = "_2d-f";
export var contrastBorder = "_2d-g";
export var greyOut = "_2d-2";
export var initialsColor0 = "_2d-3";
export var initialsColor1 = "_2d-4";
export var initialsColor10 = "_2d-d";
export var initialsColor11 = "_2d-e";
export var initialsColor2 = "_2d-5";
export var initialsColor3 = "_2d-6";
export var initialsColor4 = "_2d-7";
export var initialsColor5 = "_2d-8";
export var initialsColor6 = "_2d-9";
export var initialsColor7 = "_2d-a";
export var initialsColor8 = "_2d-b";
export var initialsColor9 = "_2d-c";
export var initialsWrapper = "_2d-1";
export var large = "_2d-l";
export var medium = "_2d-k";
export var mediumSmall = "_2d-j";
export var mediumSmallMedium = "_2d-o";
export var micro = "_2d-h";
export var small = "_2d-i";
export var tiny = "_2d-n";
export var xTiny = "_2d-m";